import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { ODIcon, ODIcons } from '../../../../icons';
import { gnbMobileOnlyToggleMenuButtonIsOpenAtomFamily } from '../../gnbCommon';
export var ODMobileOnlyToggleMenuButton = function (_a) {
    var globalKey = _a.globalKey, position = _a.position;
    var open = useRecoilValue(gnbMobileOnlyToggleMenuButtonIsOpenAtomFamily(globalKey));
    var setOpen = useSetRecoilState(gnbMobileOnlyToggleMenuButtonIsOpenAtomFamily(globalKey));
    var toggleMobile = function () { return setOpen(function (v) { return !v; }); };
    return (React.createElement("button", { className: "od-gnb-mobile-menu", onClick: toggleMobile, "od-position": position },
        !open && React.createElement(ODIcon, { icon: ODIcons.SVGIconHamburg, className: "w-6 h-6" }),
        open && React.createElement(ODIcon, { icon: ODIcons.SVGIconCloseX, className: "w-6 h-6" })));
};
//# sourceMappingURL=ODMobileOnlyToggleMenuButton.js.map